module.exports = __webpack_public_path__ + "static/media/cancel-package_1.66f24fd8.png";